export const config = {
  title: "Giulia Bartolone | Imperium Realty",
  meta: {
    description:
      "Giulia Bartolone, licensed with Imperium Realty LLC, provides expert residential real estate services in Clinton Township, MI and Macomb County.",
    keywords: [
      "Giulia Bartolone",
      "Imperium Realty Clinton Township",
      "Macomb County Realtor",
      "Homes for Sale Clinton Township",
      "Michigan Real Estate Agent"
    ],
    author: "Giulia Bartolone",
    canonicalUrl: "https://www.giuliasellsmacomb.com/",
  },
  sections: {
    header: { businessName: "Giulia Bartolone | Imperium Realty" },
    sectionB: {
      heroTitle: "Giulia Bartolone",
      heroSubtitle: "Your Macomb County Real Estate Expert",
      learnAboutText: "View Listings",
      phoneNumber: "5867330530",
      phoneLabel: "(586) 733‑0530",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2148582338/photo/new-residential-estate-houses-in-england.jpg?s=612x612&w=0&k=20&c=72q8EMez6A_uYP5bmQff-uuNYwkcNgIP_VxChq0k9ow=",
      cardData: [
        { title: "Buy a Home", description: "Find your perfect home in Macomb County." },
        { title: "Sell a Home", description: "Get top value with expert marketing and guidance." },
        { title: "Local Expertise", description: "Benefit from deep knowledge of Clinton Twp & Macomb." }
      ],
      description:
        "Giulia Bartolone of Imperium Realty LLC is dedicated to helping clients buy and sell homes throughout Macomb County, with personalized service and local insight.",
    },
    sectionC: {
      servicesTitle: "Services",
      servicesDescription: "Comprehensive real estate support for buyers and sellers.",
      cards: [
        { title: "Buyer Representation", description: "Guidance through every step of purchasing." , imageSrc:"https://media.istockphoto.com/id/2151912551/photo/building-contractor-talking-to-clients-renovating-their-house.jpg?s=612x612&w=0&k=20&c=QhL8-C4dGz4ATIhLTaFYD_tKjHTLAKWZIBsuBW_n-ms=", imageAlt:"Buying a home" },
        { title: "Selling Assistance", description: "Marketing and negotiation to maximize your sale.", imageSrc:"https://media.istockphoto.com/id/952643774/photo/real-estate-agent-with-client-or-architect-team-checking-a-housing-model-and-its-blueprints.jpg?s=612x612&w=0&k=20&c=2x40wVAFQpwQVlNTwFJLCvsQaqDIZ8z_UPIUo9K3GLw=", imageAlt:"Sell your home" },
        { title: "Market Insights", description: "Accurate analysis for informed decisions.", imageSrc:"https://media.istockphoto.com/id/2145268757/photo/real-estate-agents-are-selling-real-estate-clients-and-offering-condominiums-buyers-as-long.jpg?s=612x612&w=0&k=20&c=mW0Dq4Vlmj3AU6FSyTBfGT2PwTVzocl-5cvUmBDj6No=", imageAlt:"Market analysis" }
      ],
      otherServicesTitle: "More Services",
      otherServicesList: [
        "Relocation Assistance",
        "Investment Property Advice",
        "Open Houses & Showings",
        "Contract Negotiation",
        "Property Valuation"
      ],
    },
    sectionD: {
      aboutTitle: "About Giulia",
      aboutImage: {
        src: "https://images.marketleader.com/MarketingImages/82/2405282_normal.jpg",
        alt: "Giulia Bartolone Profile"
      },
      aboutText: [
        "Giulia Bartolone, a licensed realtor with Imperium Realty LLC, specializes in the Clinton Township and broader Macomb County market.",
        "Committed to exceptional service and results, she strives to make every real estate transaction smooth and successful for her clients."
      ],
    },
    sectionE: {
      profileImage: "https://images.marketleader.com/Logos/52/921452_normal.JPG",
      profileAlt: "Giulia Bartolone Logo",
      businessName: "Giulia Bartolone | Imperium Realty",
      contact: {
        phone: "5867330530",
        phoneLabel: "(586) 733‑0530",
        email: "giulia.bartolone13@gmail.com",
        website: "https://www.giuliasellsmacomb.com/",
        address: "20816 Marvindale St, Clinton Township, MI 48035"
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null
      },
    },
    sectionF: {
      address: "20816 Marvindale St, Clinton Township, MI 48035",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2928.7286394038673!2d-82.92914668422092!3d42.55486267917571!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8824f0be59e947a1%3A0xb71c293f255f0e88!2s20816%20Marvindale%20St%2C%20Clinton%20Twp%2C%20MI%2048035%2C%20USA!5e0!3m2!1sen!2sus!4v1718572762895!5m2!1sen!2sus"
    }
  }
};

export default config;
